import * as React from "react";
import Contact from "../components/Contact";
import Layout from "../components/Layout";
import Table from "../components/Table";
import legacyIpv4 from '../legacy-ipv4.json';
import TextBlock from "../components/TextBlock";
var Page = function Page() {
    return /*#__PURE__*/ React.createElement(Layout, {
        title: "Legacy IPv4",
        description: ""
    }, /*#__PURE__*/ React.createElement(TextBlock, {
        background: "/images/bg-lease-ipv4.jpg",
        backgroundColor: "#070b2c",
        color: "#ffffff",
        title: "Legacy IPv4"
    }, "The available prefix list is listed below"), /*#__PURE__*/ React.createElement(Table, {
        title: "Available Prefixes",
        head: ['Prefix', 'Available', 'Pricing'],
        data: legacyIpv4
    }), /*#__PURE__*/ React.createElement(Contact, null, "Do you have any ", /*#__PURE__*/ React.createElement("strong", null, "Questions"), "?. Do you need to ", /*#__PURE__*/ React.createElement("strong", null, "lease IPv4 addresses"), " with us?"));
};
export default Page;
